import { render, staticRenderFns } from "./ReportedDurationSection.vue?vue&type=template&id=80a78694&scoped=true&"
import script from "./ReportedDurationSection.vue?vue&type=script&lang=js&"
export * from "./ReportedDurationSection.vue?vue&type=script&lang=js&"
import style0 from "./ReportedDurationSection.vue?vue&type=style&index=0&id=80a78694&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a78694",
  null
  
)

export default component.exports